import { sendWebsocketMessage } from '../../../../../../../App';

export function modifyStop(tradePlanId, tacticId, previousValue, newValue) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: tacticId,
      plugin: 'CANDLE_MAGNITUDE',
      details: { modifyStop: { newValue }, previousValue },
    },

  };
  sendWebsocketMessage(msg);
}
